import { ClockIcon, WarningIcon } from '@/components/icons';
import { isStatsDataDelayed } from '@/config/httpStats';
import { formatDateTime, formatTimeOfDay } from '@/utils/date';
import './stats.css';

export interface StatsFreshnessProps {
  /** End of the complete statistics (the API's data_until); nothing is shown without it */
  dataUntil: string | null | undefined;
}

/**
 * How current the statistics are: "Data as of 12:29:00 PM" (local time), with
 * a "Delayed" badge when they lag minutes behind (a node or the collection is
 * behind)
 */
export function StatsFreshness({ dataUntil }: StatsFreshnessProps) {
  if (!dataUntil) return null;

  const isDelayed = isStatsDataDelayed(dataUntil);
  const title = isDelayed
    ? `Every node has reported up to ${formatDateTime(dataUntil)}; newer minutes are still missing from at least one node`
    : `Every node has reported up to ${formatDateTime(dataUntil)}; the range ends here`;

  return (
    <span
      className={`stats-freshness ${isDelayed ? 'stats-freshness-delayed' : ''}`.trim()}
      title={title}
      data-testid="stats-freshness"
    >
      {isDelayed ? <WarningIcon size={14} /> : <ClockIcon size={14} />}
      <span>Data as of {formatTimeOfDay(dataUntil)}</span>
      {isDelayed && <span className="stats-freshness-badge">Delayed</span>}
    </span>
  );
}
